import {React} from 'react'

const AdditionalFeatures = ({ data }) => {
  const { additionalFeatures } = data;

  return (
    <section id="about" className="about text-center">
        <div className="container">
            <div className="row">
                <div className="col-md-10 col-md-offset-1">
                    <h2 className="section-heading">{additionalFeatures.title}</h2>
                    <p className="about_p">{additionalFeatures.description}</p>
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="main_counter_content text-center white-text wow fadeInUp">
                    {additionalFeatures.counters.map((counter, index) => (
                        <div key={index} className="col-md-3 col-sm-6">
                            <div className="single_counter">
                                <p className="counter_icon"><i className={counter.icon}></i></p>
                                <span className="counter">{counter.value}</span>{counter.suffix}
                                <p>{counter.label}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section> 
  )
}

export default AdditionalFeatures
